import MeReduxState, { ActiveMembership } from './@types/MeReduxState';

import { MeAction } from '../actions/me.actions';
import MeActionEnum from '../../enums/MeAction.enum';
import { Role } from '../../__generated__/graphql';
import client from '../../client';
import { getActiveMembershipFromVirtualMembership } from '../../util/membership/virtualMembershipUtils';
import { isEqual } from 'lodash';
import { unbindRealtimeNotifications } from '../../util/realTimeNotificationUtils';

const initialState: MeReduxState = {
  activeMembership: {
    id: '',

    role: Role.User,
    tenant: {
      id: '',
      name: '',
    },
    tenantId: '',
  },
  initialized: false,
  loading: false,
  virtualMemberships: [],
};

export default function meReducer(
  state: MeReduxState = initialState,
  action: MeAction
): MeReduxState {
  switch (action.type) {
    case MeActionEnum.LOAD_ME: {
      return {
        ...state,
        loading: true,
      };
    }

    case MeActionEnum.LOG_IN: {
      return {
        ...state,
        activeMembership: action.payload.activeMembership,
        email: action.payload.email!,
        id: action.payload.id,
        initialized: true,
        loading: false,
        virtualMemberships: action.payload.virtualMemberships,
        name: action.payload.name ?? action.payload.id,
      };
    }

    case MeActionEnum.LOG_OUT: {
      unbindRealtimeNotifications(state.activeMembership.tenantId);

      client.clearStore();
      localStorage.clear();
      return initialState;
    }

    case MeActionEnum.SELECT_MEMBERSHIP: {
      const membershipVirtualId = action.payload.virtualId;

      const newMembership = state.virtualMemberships?.find((membership) =>
        isEqual(membership.virtualMembershipEntity.virtualId, membershipVirtualId)
      );

      if (!newMembership || newMembership.tenant.id !== state.activeMembership.tenantId) {
        unbindRealtimeNotifications(state.activeMembership.tenantId);
      }

      if (newMembership) {
        const newActiveMembership: ActiveMembership = getActiveMembershipFromVirtualMembership(
          newMembership
        );

        return {
          ...state,
          activeMembership: newActiveMembership,
        };
      }

      return state;
    }

    default: {
      return state;
    }
  }
}
